<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<div class="tit">关于我们</div>
				<img src="../../assets/img_public/about/banner_h501.webp" />
			</div>
			<!--banner-->
			<!--导航-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="nav_box"
			>
				<div
					v-for="(value, index) in navList"
					:key="index"
					class="nav_el"
					:class="isActived == index ? 'actived' : ''"
					@click="navChange(index)"
				>
					{{ value.title }}
				</div>
			</div>
			<!--导航-->
			<!--企业简介-->
			<template v-if="isActived == 0">
				<gsjj></gsjj>
			</template>
			<!--企业简介-->
			<!--荣誉资质-->
			<template v-if="isActived == 1">
				<ryzz></ryzz>
			</template>
			<!--荣誉资质-->
			<!--企业文化-->
			<template v-if="isActived == 2">
				<qywh></qywh>
			</template>
			<!--企业文化-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import gsjj from './gsjj/index_h5.vue'  //公司简介
import ryzz from './ryzz/index_h5.vue'  //荣誉资质
import qywh from './qywh/index_h5.vue'  //企业文化
export default {
	components:{
		navBox,
		footerBox,
		gsjj,
		ryzz,
		qywh
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[3].children;
			switch(that.$route.params.aboutId) {
				case 'introduction.html':
					that.isActived = 0;
				break;
				case 'honor.html':
					that.isActived = 1;
				break;
				case 'culture.html':
					that.isActived = 2;
				break;
			}
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//导航
	.nav_box{
		padding: 30px 0 35px 0;
		text-align: center;
		.nav_el.actived{
			border: 1px solid #C8000A;
			color: #C8000A;
		}
		.nav_el{
			display: inline-block;
			margin: 0 8px;
			padding: 5px 8px;
			border-radius: 4px;
		}
	}
	//banner
	.banner_box{
		.tit{
			padding: 14px 16px;
			font-size: 20px;
			font-weight: bold;
		}
		img{
			width: 100%;
		}
	}
}
</style>